/* Header v2: keyboard and focus behaviour for the navigation.
   assets/theme.js already handles the sticky header, the body scroll lock and closing the drawer
   on Escape or an outside click. This file only adds what a details based Shop panel and a drawer
   need on top of that, so neither file has to know about the other:
   - the Shop panel closes on Escape (focus returns to its toggle), on an outside click and when
     focus leaves it;
   - opening the drawer moves focus to its close button, Tab stays inside the drawer, and closing
     it hands focus back to the hamburger.
   No dependencies, no polyfills; if the script fails to load the header still works as plain
   HTML disclosures. */
(function () {
  'use strict';

  var drops = Array.prototype.slice.call(document.querySelectorAll('details[data-nav-drop]'));

  function closeDrop(drop, returnFocus) {
    if (!drop.open) return;
    drop.removeAttribute('open');
    if (returnFocus) {
      var summary = drop.querySelector('summary');
      if (summary) summary.focus();
    }
  }

  if (drops.length) {
    document.addEventListener('click', function (e) {
      drops.forEach(function (drop) {
        if (!drop.contains(e.target)) closeDrop(drop, false);
      });
    });
    document.addEventListener('focusin', function (e) {
      drops.forEach(function (drop) {
        if (!drop.contains(e.target)) closeDrop(drop, false);
      });
    });
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape' && e.key !== 'Esc') return;
      drops.forEach(function (drop) { closeDrop(drop, true); });
    });
  }

  var menu = document.querySelector('details[data-menu]');
  var panel = menu ? menu.querySelector('[data-menu-panel]') : null;
  var opener = menu ? menu.querySelector('summary') : null;
  if (!menu || !panel || !opener) return;

  function focusable() {
    var nodes = panel.querySelectorAll('a[href], button:not([disabled]), summary, input:not([type="hidden"])');
    return Array.prototype.filter.call(nodes, function (el) {
      return el.getClientRects().length > 0;
    });
  }

  menu.addEventListener('toggle', function () {
    if (menu.open) {
      var close = panel.querySelector('[data-menu-close]');
      if (close) close.focus({ preventScroll: true });
      return;
    }
    /* A browser drops focus to the body when the focused element stops being rendered, which is
       exactly what closing the drawer does. Only then is the hamburger the right place to land. */
    if (document.activeElement === document.body || document.activeElement === null) {
      opener.focus({ preventScroll: true });
    }
  });

  menu.addEventListener('keydown', function (e) {
    if (e.key !== 'Tab' || !menu.open) return;
    var items = focusable();
    if (!items.length) return;
    var first = items[0];
    var last = items[items.length - 1];
    if (e.shiftKey && (document.activeElement === first || document.activeElement === opener)) {
      e.preventDefault();
      last.focus();
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault();
      first.focus();
    }
  });
})();
